module.exports = __webpack_public_path__ + "static/media/Group 15456.1686beab.png";